import Axios from 'axios'

export default {
  namespaced: true,
  state: {
    forgotPasswordResponse: null
  },
  getters: {
    FORGOT_PASSWORD_RESPONSE: state => state.forgotPasswordResponse
  },
  mutations: {
    SET_FORGOT_PASSWORD_RESPONSE: (state, payload) => {
      state.forgotPasswordResponse = payload
    }
  },
  actions: {
    SEND_FORGOT_PASSWORD: async (context, payload) => {
      try {
        const response = await Axios.post('/pub/forgot-password', payload)
        context.commit('SET_FORGOT_PASSWORD_RESPONSE', response)
      } catch (error) {
        context.commit('SET_FORGOT_PASSWORD_RESPONSE', error.response)
      }
    }
  }
}
